export const ERROR_MESSAGE = {
  server: {
    title: "Your order didn't go through",
    message:
      'We are unable to process your order. Please try again or contact Canine Care to complete your order.',
  },
  address: {
    title: `Your order didn't go through`,
    message:
      'We are unable to process your address. Please review or contact Canine Care to complete your order.',
    fieldName: 'address',
  },
  passwordNotSet: {
    title: `Your order didn't go through`,
    message:
      'We are unable to set your password. Please update your password and try again.',
    fieldName: 'password',
  },
  stripePaymentInvalid: (message = 'Your payment method is invalid.') => ({
    title: `Your order didn't go through`,
    message,
    fieldName: 'cardNumber',
  }),
  paymentInvalid: {
    title: `Your order didn't go through`,
    message: 'Your payment method is invalid.',
    fieldName: 'cardNumber',
  },
  paymentInsufficientFunds: {
    title: `Your order didn't go through`,
    message:
      'Your payment method has insufficient funds. Please review your information or try a new payment method or contact Canine Care to complete your order.',
    fieldName: 'cardNumber',
  },
  unableToProcessOrder: {
    title: `Your order didn't go through`,
    message:
      'We are unable to process your order. Please try again or contact Canine Care to complete your order.',
  },
};
